module.exports = __webpack_public_path__ + "static/media/ropaaa.aac08aea.png";